import { Component } from '@angular/core';
import { TranslationService } from '../../service/translation.service';

@Component({
  selector: '[app-sdp-footer]',
  templateUrl: './sdp-footer.component.html',
  styleUrls: ['./sdp-footer.component.css']
})
export class SdpFooterComponent {
  constructor(public translation: TranslationService) { }
}
